<template>
    <div id="Wrapper">
        <!-- <div>
            <input id="PW4Email" />
            <input id="NewPassword" />
            <button @click="SetNewPassword">Set PW</button>
        </div> -->
        <div style="display: grid; place-content: center;">
            <img style="width: 128px; height: 128px;" width="128" height="128" src="@/assets/Logo_SACHIKO_Analytics_512.png" />
        </div>
        <div style="display: grid; justify-content: center;">
            <div id="LoginContainer">
                <div class="LoginContentContainer">
                    <div class="InputLabel localize" data-key="text.email">メール</div>
                    <input id="Email" type="text" />
                </div>
                <div class="LoginContentContainer">
                    <div class="InputLabel localize" data-key="text.password">パスワード</div>
                    <input id="Password" type="password" />
                </div>
                <div class="LoginContentContainer">
                    <div id="LoginButton" class="Button ButtonGreen LoginRegPageButton localize" data-key="text.login" @click="Login">ログイン</div>
                    <!-- <div id="VerificationButton" class="Button ButtonGreen LoginRegPageButton" @click="RequestVerification">メール認証</div> -->
                    <div id="RegisterButton" style="margin-top: 25px;" class="Button ButtonGreen LoginRegPageButton localize" data-key="text.register" @click="OpenRegistration">登録する</div>
                    <div id="ForgotPWButton" class="Button ButtonGreen LoginRegPageButton localize" data-key="text.forgotpassword" @click="OpenForgotPassword">パスワード忘れた方</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {mapActions} from 'vuex';

export default {
    mounted(){
        let self = this;

        this.$ClearSessionInfo();

        let inp = document.getElementById('Email');
        inp.addEventListener('keypress', function(event)
        {
            if (event.key === 'Enter')
            {
                self.Login();
            }
        });

        inp = document.getElementById('Password');
        inp.addEventListener('keypress', function(event)
        {
            if (event.key === 'Enter')
            {
                self.Login();
            }
        });
    },
    methods:{
        async SetNewPassword()
        {
            let param = {
                Email: document.getElementById('PW4Email').value,
                Password: document.getElementById('NewPassword').value,
            };

            const result = await axios.post(process.env.VUE_APP_BACKEND_URL + 'setpassword', param)
            .then(async response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });

            console.log('set password result', result);
        },
        async Login() 
        {
            let data = {
                Email: document.getElementById("Email").value,
                Password: document.getElementById("Password").value,
            };
            
            await axios.post(process.env.VUE_APP_BACKEND_URL + "login", data)
            .then(async response =>
            {
                console.log(response.data);
                this.saveToken(response.data.Token);
                this.$SetToken(response.data.Token);
                this.$SetUserID(response.data.UserID);
                this.$SetUsername(response.data.Username);
                this.$router.push('/analytics');
            })
            .catch(error =>
            {
                this.$ClearSessionInfo();
                console.log("Received error", error);
                if (error.response.status == 400){
                    alert(error.response.data);
                }
            });
        },
        async RequestVerification()
        {
            let data = {
                Email: document.getElementById("Email").value,
            };

            const result = await axios.post(process.env.VUE_APP_BACKEND_URL + "request_verification", data)
            .then(async response => {
                console.log('sent', response.data);
                return response.data;
            })
            .catch(error =>
            {
                console.log("Received error", error);
                if (error.response.status == 400){
                    alert(error.response.data);
                }
            });

            alert(result.Result);
        },
        OpenRegistration()
        {
            this.$router.push('/register');
        },
        OpenForgotPassword()
        {
            // alert("まだ実装していません。");
            this.$router.push('/forgotpassword');
        },
        ...mapActions(['saveToken']),
    }
}
</script>

<style>
input
{
    height: 30px;
    border-radius: 10px;
}

#Wrapper
{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: unset;
    align-content: unset;
}

#LoginContainer
{
    padding: 30px 25px;
    background-color: rgb(90, 196, 189);
    border-radius: 20px;
    width: 400px;
    color: #fff;
}

#LoginContainer input
{
    width: 100%;
}

.LoginContentContainer
{

}

#LoginButton
{

}

.LoginRegPageButton
{
    display: grid;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 8px;
}

.LinkText
{
    cursor: pointer;
    color: #00f;
}

.InputLabel
{
    font-weight: bold;;
    margin-bottom: 8px;
}

#LoginContainer .LoginContentContainer + .LoginContentContainer
{
    margin-top: 20px;
}

.LoginContentContainer div + div
{
    margin-top: 10px;
}
</style>